const pricingPlans = {
    monthlyClub: [
        {
            planName: 'Free',
            planId: '',
            ePaycoPlanId: '',
            currency: 'USD',
            billed: 'Billed monthly',
            price: 0.0,
            color: 'white',
            icon: '',
            properties: {
                en: [
                    "10 member capacity",
                    "General publications",
                    "General events",
                    "Access the members' blog" 
                ],
                es: [
                    "Capacidad de 10 miembros",
                    "Publicaciones generales",
                    "Eventos generales",
                    "Accede a la bitácora de los miembros"
                ]
            }
        },
        {
            planName: 'Basic Pro',
            planId: 'P-70S34311KH469643DMEWR3CA',
            ePaycoPlanId: 'Monthly_Basic_Pro_Community',
            currency: 'USD',
            billed: 'Billed monthly',
            price: 99.0,
            color: 'blue',
            icon: '',
            properties: {
                en: [
                    "25 member capacity",
                    "Swiset Pro to all members",
                    "General and channel chat",
                    "Creation of public channels" 
                ],
                es: [
                    "Capacidad de 25 miembros",
                    "Swiset Pro a todos los miembros",
                    "Chat general y por canales",
                    "Creación de canales públicos"
                ]
            }
        },
        {
            planName: 'Silver Pro',
            planId: 'P-0PA51028L21305231MEWSFZY',
            ePaycoPlanId: 'Monthly_Silver_Pro_Community',
            currency: 'USD',
            billed: 'Billed monthly',
            price: 149.0,
            color: 'silver',
            icon: '',
            properties: {
                en: [
                    "50 member capacity",
                    "Consolidated Returns Module",
                    "Public and private channels",
                    "Creation of 1 tournament per month"
                ],
                es: [
                    "Capacidad de 50 miembros",
                    "Módulo de Rendimientos Consolidados",
                    "Canales públicos y privados",
                    "Creación de 1 torneo por mes"
                ]
            }
        },
        {
            planName: 'Black Pro',
            planId: 'P-7HF194924S979792XMEWSGJA',
            ePaycoPlanId: 'Monthly_Black_Pro_Community',
            currency: 'USD',
            billed: 'Billed monthly',
            price: 249.0,
            color: 'black',
            icon: '',
            properties: {
                en: [
                    "100 member capacity",
                    "Unlimited tournaments creation",
                    "Tournament payout settings",
                    "Trading Room module by channels"
                ],
                es: [
                    "Capacidad de 100 miembros",
                    "Creación ilimitada de torneos",
                    "Configuración de pagos en torneos",
                    "Módulo de Trading Room por canales"
                ]
            }
        }
    ],
    semiannualClub: [
        {
            planName: 'Free',
            planId: '',
            ePaycoPlanId: '',
            currency: 'USD',
            billed: 'Billed semiannually',
            price: 0.0,
            color: 'white',
            icon: '',
            properties: {
                en: [
                    "10 member capacity",
                    "General publications",
                    "General events",
                    "Access the members' blog" 
                ],
                es: [
                    "Capacidad de 10 miembros",
                    "Publicaciones generales",
                    "Eventos generales",
                    "Accede a la bitácora de los miembros"
                ]
            }
        },
        {
            planName: 'Basic Pro',
            planId: 'P-8RD73775NY445683KMEWS5VA',
            ePaycoPlanId: 'Semiannually_Basic_Pro_Community',
            currency: 'USD',
            billed: 'Billed semiannually',
            price: 495.0,
            color: 'blue',
            icon: '',
            properties: {
                en: [
                    "25 member capacity",
                    "Swiset Pro to all members",
                    "General and channel chat",
                    "Creation of public channels" 
                ],
                es: [
                    "Capacidad de 25 miembros",
                    "Swiset Pro a todos los miembros",
                    "Chat general y por canales",
                    "Creación de canales públicos"
                ]
            }
        },
        {
            planName: 'Silver Pro',
            planId: 'P-9WN746171Y603742SMEWS6AY',
            ePaycoPlanId: 'Semiannually_Silver_Pro_Community',
            currency: 'USD',
            billed: 'Billed semiannually',
            price: 745.0,
            color: 'silver',
            icon: '',
            properties: {
                en: [
                    "50 member capacity",
                    "Consolidated Returns Module",
                    "Public and private channels",
                    "Creation of 1 tournament per month"
                ],
                es: [
                    "Capacidad de 50 miembros",
                    "Módulo de Rendimientos Consolidados",
                    "Canales públicos y privados",
                    "Creación de 1 torneo por mes"
                ]
            }
        },
        {
            planName: 'Black Pro',
            planId: 'P-5DV259687R606722TMEWSMGQ',
            ePaycoPlanId: 'Semiannually_Black_Pro_Community',
            currency: 'USD',
            billed: 'Billed semiannually',
            price: 1245.0,
            color: 'black',
            icon: '',
            properties: {
                en: [
                    "100 member capacity",
                    "Unlimited tournaments creation",
                    "Tournament payout settings",
                    "Trading Room module by channels"
                ],
                es: [
                    "Capacidad de 100 miembros",
                    "Creación ilimitada de torneos",
                    "Configuración de pagos en torneos",
                    "Módulo de Trading Room por canales"
                ]
            }
        }
    ],
    annuallyClub: [
        {
            planName: 'Free',
            planId: '',
            ePaycoPlanId: '',
            currency: 'USD',
            billed: 'Billed yearly',
            price: 0.0,
            color: 'white',
            icon: '',
            properties: {
                en: [
                    "10 member capacity",
                    "General publications",
                    "General events",
                    "Access the members' blog" 
                ],
                es: [
                    "Capacidad de 10 miembros",
                    "Publicaciones generales",
                    "Eventos generales",
                    "Accede a la bitácora de los miembros"
                ]
            }
        },
        {
            planName: 'Basic Pro',
            planId: 'P-0LP18285VR866253PMEWS65I',
            ePaycoPlanId: 'Annually_Basic_Pro_Community',
            currency: 'USD',
            billed: 'Billed yearly',
            price: 990.0,
            color: 'blue',
            icon: '',
            properties: {
                en: [
                    "25 member capacity",
                    "Swiset Pro to all members",
                    "General and channel chat",
                    "Creation of public channels" 
                ],
                es: [
                    "Capacidad de 25 miembros",
                    "Swiset Pro a todos los miembros",
                    "Chat general y por canales",
                    "Creación de canales públicos"
                ]
            }
        },
        {
            planName: 'Silver Pro',
            planId: 'P-2B334057ES020852JMEWS7JA',
            ePaycoPlanId: 'Annually_Silver_Pro_Community',
            currency: 'USD',
            billed: 'Billed yearly',
            price: 1490.0,
            color: 'silver',
            icon: '',
            properties: {
                en: [
                    "50 member capacity",
                    "Consolidated Returns Module",
                    "Public and private channels",
                    "Creation of 1 tournament per month"
                ],
                es: [
                    "Capacidad de 50 miembros",
                    "Módulo de Rendimientos Consolidados",
                    "Canales públicos y privados",
                    "Creación de 1 torneo por mes"
                ]
            }
        },
        {
            planName: 'Black Pro',
            planId: 'P-1TJ005754R9692021MEWS7UY',
            ePaycoPlanId: 'Annually_Black_Pro_Community',
            currency: 'USD',
            billed: 'Billed yearly',
            price: 2490.0,
            color: 'black',
            icon: '',
            properties: {
                en: [
                    "100 member capacity",
                    "Unlimited tournaments creation",
                    "Tournament payout settings",
                    "Trading Room module by channels"
                ],
                es: [
                    "Capacidad de 100 miembros",
                    "Creación ilimitada de torneos",
                    "Configuración de pagos en torneos",
                    "Módulo de Trading Room por canales"
                ]
            }
        }
    ],
};

export default pricingPlans;
